//
// PickResultEntryInfo.js
// BIRD
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import ClosetObject from "@sas-dvr/ltjs-commons/ClosetObject";
import "../../lib";

var PickResultEntryInfo = createModule("BIRD::PickResultEntryInfo", [], ClosetObject, [
    ,
    ,
    ,
    ,
    {
        getValue: [7],
        getLabel: [7],
        getColor: [3],
    },
    ,
    ,
]);
export default PickResultEntryInfo;
